<template>
  <Form
    :model="appModel"
    :label-width="150"
    class="app_form"
    ref="appRef"
    :rules="ruleValidate"
    :label-colon="true"
  >
    <Card class="add_card_div">
      <Divider orientation="left"
        ><div class="card_title">Basic information</div></Divider
      >
      <Row :gutter="16">
        <Col :span="12">
          <FormItem label="App name" prop="name">
            <Input
              v-model.trim="appModel.name"
              clearable
              :maxlength="120"
              @on-keyup="btKeyUp($event)"
              placeholder="Please enter the app name"
              :disabled="isDisabled"
            />
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem label="Description" prop="describe">
            <Input
              v-model.trim="appModel.describe"
              :maxlength="300"
              show-word-limit
              placeholder="Please enter the app description, <300 characters"
              :disabled="isDisabled"
            />
          </FormItem>
        </Col>
        <Col :span="6">
          <FormItem label="App folder" prop="folder">
            <Select
              v-model="appModel.folder"
              clearable
              placeholder="Please select the app folder"
              :disabled="isDisabled"
            >
              <Option
                v-for="(item, index) in folderArr"
                :key="index"
                :value="item.id"
                >{{ item.appName }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :span="6">
          <FormItem label="App code" prop="snCode">
            <Input
              v-model.trim="appModel.snCode"
              :maxlength="100"
              placeholder="Please enter the app code"
              :disabled="isDisabled"
            />
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem label="App type" prop="appType">
            <Select
              v-model="appModel.appType"
              clearable
              placeholder="Please select the app type"
              :disabled="isDisabled"
            >
              <Option
                v-for="(item, index) in appTypeArr"
                :key="index"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col :span="6">
          <FormItem label="Shelves or not" prop="shelfStatuses">
            <i-switch
              :disabled="isDisabled"
              v-model="appModel.shelfStatuses"
              @on-change="shelfChange"
            ></i-switch>
          </FormItem>
        </Col>
        <Col :span="6">
          <FormItem label="Default Install" prop="defaultInstall">
            <i-switch
              :disabled="isDisabled || shelfIsFalse"
              v-model="appModel.defaultInstall"
            ></i-switch>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem label="Background color" prop="backGround">
            <Row :gutter="16">
              <Col :span="18">
                <Input
                  v-model.trim="appModel.backGround"
                  clearable
                  :disabled="isDisabled"
                />
              </Col>
              <Col :span="6">
                <ColorPicker
                  v-model="appModel.backGround"
                  alpha
                  :disabled="isDisabled"
                />
              </Col>
            </Row>
          </FormItem>
        </Col>
      </Row>
    </Card>
    <Card class="add_card_div">
      <Divider orientation="left">
        <div class="card_title">Photo and text information</div>
      </Divider>
      <Row>
        <Col :span="12">
          <FormItem label="Icon" prop="appAvatar">
            <div class="info_text">(Image size cannot exceed 2M)</div>
            <Input class="hide_div" v-model.trim="appModel.appAvatar" />
            <UploadPic
              @uploadImageKey="appHeadKey"
              @deleteImageKey="deleteAppHeadKey"
              :defalutImage="appModel.appAvatar"
              :disabled="isDisabled"
              :limitSize="2"
            />
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem label="App image" prop="appImage">
            <div class="info_text"></div>
            <Input class="hide_div" v-model.trim="appModel.appImage" />
            <UploadPic
              @uploadImageKey="appImageKey"
              @deleteImageKey="deleteAppImageKey"
              :defalutImage="appModel.appImage"
              :disabled="isDisabled"
            />
          </FormItem>
        </Col>
        <Col :span="24">
          <FormItem label="App screenshot" prop="screenshots">
            <div class="info_text">
              (The size of the product picture cannot exceed 2M)
              <!-- , drag the picture to sort -->
            </div>
            <Select class="hide_div" v-model="appModel.screenshots"></Select>
            <UploadPic
              @uploadImageKey="screenshotKey($event, index)"
              @deleteImageKey="deleteScreenshotKey"
              v-for="(item, index) in 5"
              :key="index"
              :defalutImage="appModel.screenshots[index]"
              :disabled="isDisabled"
              :limitSize="2"
            />
          </FormItem>
        </Col>
        <Col :span="24">
          <FormItem label="App details" prop="detail">
            <Input
              type="textarea"
              v-model.trim="appModel.detail"
              :rows="6"
              :maxlength="5000"
              show-word-limit
              :disabled="isDisabled"
            />
          </FormItem>
        </Col>
      </Row>
    </Card>
    <Card class="add_card_div">
      <Divider orientation="left">
        <div class="card_title">Upload app</div>
      </Divider>
      <FormItem label="Display Method" prop="uploadTarget" :labelWidth="180">
        <RadioGroup v-model="appModel.uploadTarget">
          <Radio
            v-for="(item, index) in uploadTargetArr"
            :key="index"
            :label="item.value"
            :disabled="isDisabled"
            >{{ item.name }}</Radio
          >
        </RadioGroup>
      </FormItem>
      <FormItem label="Upload Method" prop="uploadMethod" :labelWidth="180">
        <RadioGroup v-model="appModel.uploadMethod">
          <Radio
            v-for="(item, index) in uploadMethodList"
            :key="index"
            :label="item.value"
            :disabled="isDisabled"
            >{{ item.name }}</Radio
          >
        </RadioGroup>
      </FormItem>
      <div style="width: 100%; padding-left: 180px; box-sizing: border-box">
        <div v-if="appModel.uploadMethod == 1">
          <Row>
            <Col :span="16">
              <FormItem label="Upload URL" prop="uploadUrl" :labelWidth="110">
                <Input
                  v-model.trim="appModel.uploadUrl"
                  placeholder="Please enter your address"
                  :disabled="isDisabled"
                />
              </FormItem>
            </Col>
          </Row>
        </div>
        <div v-else>
          <Row>
            <Col :span="16">
              <FormItem
                label="Apollo App URL Set Key "
                prop="appApolloURLConfigKey"
                :labelWidth="191"
              >
                <Select
                  v-model="appModel.appApolloURLConfigKey"
                  clearable
                  placeholder="Please select the Apollo App URL Set Key"
                  :disabled="isDisabled"
                >
                  <Option
                    v-for="(item, index) in appApolloList"
                    :key="index"
                    :value="item.value"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col :span="16">
              <FormItem
                label="App Routing "
                prop="appRoute"
                :labelWidth="195"
                class="spc_label"
              >
                <Input
                  v-model.trim="appModel.appRoute"
                  clearable
                  :disabled="isDisabled"
                />
              </FormItem>
            </Col>
          </Row>
        </div>
      </div>
      <Row :gutter="16">
        <Col :span="16">
          <FormItem label="App Parameter" prop="appParams" :labelWidth="180">
            <Input
              v-model.trim="appModel.appParams"
              clearable
              :disabled="isDisabled"
              placeholder="Setting Parameter (string)"
            />
          </FormItem>
        </Col>
      </Row>
      <row>
        <Col :span="4">
          <FormItem label="Enabled" prop="isEnabled" :labelWidth="180">
            <span style="position: relative">
              <i-switch
                v-model="appModel.isEnabled"
                :disabled="isDisabled"
              ></i-switch>
              <Poptip
                trigger="hover"
                class="enabled_info"
                content="After shut down,Users will not be able to access the application"
                ><Icon type="ios-alert-outline" :size="22"
              /></Poptip>
            </span>
          </FormItem>
        </Col>
      </row>
      <div class="confirm_button">
        <Button @click="cancelFun">Cancel</Button>
        <Button
          type="primary"
          @click="confirmFun"
          :loading="appLoading"
          :disabled="isDisabled"
          >Confirm</Button
        >
      </div>
    </Card>
  </Form>
</template>

<script>
import apiRoutes from "@/config/API_ROUTER";
import UploadPic from "./UploadPic";

export default {
  data() {
    return {
      isDisabled: false,
      appLoading: false,
      appId: "",
      appModel: {
        name: "",
        describe: "",
        folder: "",
        appType: "",
        appSourceType: 1,
        shelfStatuses: true,
        backGround: "#ffffff",
        appAvatar: "",
        appImage: "",
        detail: "",
        screenshots: [],
        uploadTarget: 1,
        uploadMethod: 1,
        uploadUrl: "",
        isEnabled: true,
        defaultInstall: false,
        folderaction: "",
        appParams: "",
        appRoute: "",
        appApolloURLConfigKey: "",
      },
      appApolloList: [], // apollo配置
      uploadMethodList: [], // 上传方式
      folderArr: [],
      appTypeArr: [],
      uploadTargetArr: [],
      systemList: [
        {
          id: 1,
          name: "test",
        },
      ],
      locationName1: "",
      locationName2: "",
      locationName3: "",
      highlightValue: "false",
      asset: {
        id: "",
        status: 0,
        highlight: false,
        name: "",
        systemId: null,
        typeId: null,
        // locationName: "",
        description: "",
        brand: "",
        material: "",
        remarks: "",
        bimid: "",
        // BIMID: "",
        // RFID: "",
        document: "",
        attributes: "",
        projectId: "2d3919b5-98f8-4cb0-99f6-08d9dbfc1b76",
        image: "",
        locationBuildingId: "",
        locationFloorId: "",
        locationRoomId: "",
      },
      locationBuildingArr: [],
      locationFloorArr: [],
      locationRoomArr: [],
      showBuilding: false,
      showFloor: false,
      showRoom: false,
      systemArr: [],
      documentArr: [
        {
          desc: "",
          path: "",
        },
      ],
      FolderList: [
        {
          value: 1,
          name: "平台内嵌",
        },
        {
          value: 2,
          name: "平台路由",
        },
        {
          value: 3,
          name: "新窗口内嵌",
        },
        {
          value: 4,
          name: "新窗口路由",
        },
      ],
      ruleValidate: {
        name: [
          {
            required: true,
            message: "The App name cannot be empty",
            trigger: "blur",
          },
        ],
        describe: [
          {
            required: true,
            message: "The Description cannot be empty",
            trigger: "blur",
          },
        ],
        folder: [
          {
            required: true,
            message: "The App folder cannot be empty",
            trigger: "change",
            type: "number",
          },
        ],
        snCode: [
          {
            required: true,
            message: "The App code cannot be empty",
            trigger: "blur",
          },
        ],
        appType: [
          {
            required: true,
            message: "The App type cannot be empty",
            trigger: "change",
            type: "number",
          },
        ],
        shelfStatuses: [
          {
            required: true,
            message: "The Shelves cannot be empty",
            type: "boolean",
          },
        ],
        screenshots: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "The screenshots cannot be empty",
            trigger: "change",
          },
        ],
        appAvatar: [
          {
            required: true,
            message: "The Avatar cannot be empty",
            type: "string",
          },
        ],
        appImage: [
          {
            required: true,
            message: "The App Image cannot be empty",
            type: "string",
          },
        ],
        uploadUrl: [
          {
            required: true,
            message: "The Upload Url cannot be empty",
            trigger: "blur",
          },
        ],
        uploadTarget: [
          {
            required: true,
            message: "The uploadTarget cannot be empty",
            trigger: "change",
            type: "number",
          },
        ],
        uploadMethod: [
          {
            required: true,
            message: "The uploadMethod cannot be empty",
            trigger: "change",
            type: "number",
          },
        ],
        appApolloURLConfigKey: [
          {
            required: true,
            message: "The appApolloURLConfigKey cannot be empty",
            trigger: "change",
            type: "string",
          },
        ],
        appRoute: [
          {
            required: true,
            message: "The appRoute cannot be empty",
            trigger: "blur",
          },
        ],
      },
      idObj: {
        // BIMID: "",
        RFID: "",
      },
      shelfIsFalse: false,
    };
  },
  methods: {
    btKeyUp() {
      const value = this.appModel.name.replace(/\s+/gi, " ");
      this.appModel.name = value.trim();
    },
    shelfChange(val) {
      if (val) {
        this.shelfIsFalse = false;
      } else {
        this.shelfIsFalse = true;
        this.appModel.defaultInstall = false;
      }
    },
    appHeadKey(key) {
      this.appModel.appAvatar = key;
    },
    deleteAppHeadKey() {
      this.appModel.appAvatar = "";
    },
    appImageKey(key) {
      this.appModel.appImage = key;
    },
    deleteAppImageKey() {
      this.appModel.appImage = "";
    },
    screenshotKey(key, index) {
      this.appModel.screenshots[index] = key;
    },
    deleteScreenshotKey(key) {
      if (this.appModel.screenshots.includes(key)) {
        const i = this.appModel.screenshots.indexOf(key);
        this.appModel.screenshots.splice(i, 1);
      }
    },
    getLocation() {
      const url = apiRoutes.Location;
      this.$http.get(url).then((res) => {
        this.showBuilding = false;
        this.showRoom = false;
        this.showFloor = false;
        const { data } = res.data;
        if (res.data.message === "Succeed") {
          for (let i = 0; i < data.length; i += 1) {
            if (data[i].sort === 1) {
              // building
              this.locationName1 = data[i].locationLevelName;
              this.showBuilding = true;
              this.locationBuildingArr = data[i].listData;
            }
            if (data[i].sort === 2) {
              // floor
              this.locationName2 = data[i].locationLevelName;
              this.showRoom = true;
              this.locationRoomArr = data[i].listData;
            }
            if (data[i].sort === 3) {
              // room
              this.locationName3 = data[i].locationLevelName;
              this.showFloor = true;
              this.locationFloorArr = data[i].listData;
            }
          }
        }
      });
    },
    uploadImageKeyFun(key) {
      this.asset.image = key;
    },
    addDocumentFn() {
      const row = {
        desc: "",
        path: "",
      };
      this.documentArr.push(row);
    },
    deleteDocumentFn(index) {
      this.documentArr.splice(index, 1);
    },
    addAssetFn() {
      const self = this;
      this.$refs.asset.validate((valid) => {
        if (valid) {
          self.issureAdd();
        } else {
          self.$Message.error("Fail!");
          self.$emit("isAddSuccess", false);
          self.$emit("saveLoadingEmit", false);
        }
      });
    },

    issureAdd() {
      const self = this;
      switch (this.highlightValue) {
        case "false":
          this.asset.highlight = false;
          break;
        case "true":
          this.asset.highlight = true;
          break;
        default:
          break;
      }
      this.asset.document = JSON.stringify(this.documentArr);
      this.asset.attributes = JSON.stringify(this.idObj);
      const params = {};
      Object.keys(this.asset).forEach((key) => {
        if (this.asset[key]) {
          params[key] = this.asset[key];
        }
      });
      const url = apiRoutes.Asset;
      // 新增
      if (!params.id) {
        this.$http.post(url, params).then((res) => {
          // // console.log(res);
          self.$emit("saveLoadingEmit", false);
          if (res.data.message === "Succeed") {
            this.$Message.success("Success!");
            self.$emit("isAddSuccess", true);
          } else {
            this.$Notice.error({
              title: "Error",
              desc: res.data.Message,
              duration: 25,
            });
            self.$emit("isAddSuccess", false);
          }
        });
      } else {
        // 编辑
        // // console.log(params.id);

        this.$http.put(`${url}/${params.id}`, params).then((res) => {
          // // console.log(res);
          self.$emit("saveLoadingEmit", false);
          if (res.data.message === "Succeed") {
            this.$Message.success("Success!");
            self.$emit("isAddSuccess", true);
          } else {
            this.$Notice.error({
              title: "Error",
              desc: res.data.Message,
              duration: 10,
            });
            self.$emit("isAddSuccess", false);
          }
        });
      }
    },
    init() {
      this.appTypeArr = window.defaultObj.appType;
      this.uploadTargetArr = window.defaultObj.uploadTarget;
      this.appApolloList = window.defaultObj.appApollo;
      this.uploadMethodList = window.defaultObj.uploadMethodList;
      const { view } = this.$route.query;
      this.isDisabled = view === "true";
      this.appId = this.$route.query.appid;
      if (this.appId) {
        this.getDataFun();
      }
      // 获取文件夹数组
      this.getfolderArr();
    },
    // 获取文件夹数组
    getfolderArr() {
      const url = apiRoutes.AppFolder;
      this.$http.get(url).then((res) => {
        if (res.status === 200) {
          this.folderArr = res.data.data;
        }
      });
    },
    cancelFun() {
      this.$router.push({
        path: "/Application",
      });
    },
    confirmFun() {
      // console.log(this.appModel);
      this.$refs.appRef.validate((valid) => {
        if (valid) {
          this.appLoading = true;
          if (this.appId) {
            this.editDataFun();
          } else {
            this.addDataFun();
          }
        } else {
          this.$Notice.error({
            title: "Reminder",
            desc: "Please input",
          });
        }
      });
    },
    addDataFun() {
      const url = apiRoutes.ManageApp;
      this.$http
        .post(url, this.appModel)
        .then((res) => {
          // console.log(res);
          if (res.data) {
            this.$Message.success("Added Successfully");
            setTimeout(() => {
              this.$router.push({
                path: "/Application",
              });
            }, 600);
          } else {
            this.$Message.error("Failed to add");
          }
          this.appLoading = false;
        })
        .catch((e) => {
          this.appLoading = false;
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 25,
          });
        });
    },
    editDataFun() {
      const url = `${apiRoutes.ManageApp}/${this.appId}`;
      this.$http
        .put(url, this.appModel)
        .then((res) => {
          // console.log(res);
          if (res.data) {
            this.$Message.success("Edit Successfully");
            setTimeout(() => {
              this.$router.push({
                path: "/Application",
              });
            }, 600);
          } else {
            this.$Message.error("Failed to add");
          }
          this.appLoading = false;
        })
        .catch((e) => {
          this.appLoading = false;
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 25,
          });
        });
    },
    getDataFun() {
      const url = `${apiRoutes.ManageApp}/${this.appId}`;
      this.$http
        .get(url)
        .then((res) => {
          // console.log(res);
          if (res.data.message === "Succeed") {
            this.appModel = res.data.data;
            // let d = res.data.data;
            // this.$set(this.appModel, 'folder', d.folder);
            // this.appModel.folder = 8;
          }
        })
        .catch((e) => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 25,
          });
        });
    },
  },
  created() {
    this.init();
  },
  components: {
    // UploadImage,
    UploadPic,
  },
};
</script>

<style lang="less">
.app_form {
  .add_card_div {
    margin-bottom: 16px;
    .confirm_button {
      text-align: center;
      padding: 20px 0;
      .ivu-btn {
        margin: 0 30px;
      }
    }
  }
  .hide_div {
    display: none;
  }
  .info_text {
    font-size: 12px;
    color: #999;
    min-height: 32px;
  }
  .enabled_info {
    position: absolute;
    right: -33px;
    top: -3px;
  }
}
.spc_label label {
  text-align: left !important;
}
</style>
